// Super Admin Actions
export const SUPER_ADMIN_TYPES = {
  GET_SUPER_ADMIN_ANALYTICS: "GET_SUPER_ADMIN_ANALYTICS",
  GET_USAGE_ANALYTICS: "GET_USAGE_ANALYTICS",
  GET_RETENTION_ANALYTICS: "GET_RETENTION_ANALYTICS",
};
